import { GetListParams, GetOneParams } from 'react-admin';
import { CustomDataProvider } from '../../providers/CustomDataProvider';
import { baseUrl, httpClient } from '../../providers/AppDataProvider';
import { Resources } from '../resource';
import { API_PATH, filterToApiParams, fromApiRecord, toApiPayload } from './utils';

const RESOURCE = Resources.announcementPopup;

export class MaintenanceBannerDataProvider implements CustomDataProvider {
  // eslint-disable-next-line class-methods-use-this
  async getList(_resource: string, params: GetListParams): Promise<any> {
    if (_resource !== RESOURCE) return Promise.reject(new Error('Unsupported getList resource'));

    const { page = 1, perPage = 10 } = params.pagination || {};
    const searchParams = new URLSearchParams({
      page: String(page),
      pageSize: String(perPage),
    });

    Object.entries(filterToApiParams(params.filter ?? {})).forEach(([key, value]) => {
      searchParams.set(key, value);
    });

    const url = `${baseUrl}/${API_PATH}?${searchParams.toString()}`;
    const { json } = await httpClient(url);
    const rows: any[] = json?.data ?? json?.items ?? [];
    const total = json?.total ?? rows.length;

    return {
      data: rows.map(fromApiRecord),
      total,
    };
  }

  // eslint-disable-next-line class-methods-use-this
  async getOne(_resource: string, params: GetOneParams): Promise<any> {
    if (_resource !== RESOURCE) return Promise.reject(new Error('Unsupported getOne resource'));

    const url = `${baseUrl}/${API_PATH}/${params.id}`;
    const { json } = await httpClient(url);
    const data = json?.data ?? json;
    return { data: fromApiRecord({ id: params.id, ...data }) };
  }

  // eslint-disable-next-line class-methods-use-this
  async create(_resource: string, params: { data: Record<string, unknown> }): Promise<any> {
    if (_resource !== RESOURCE) return Promise.reject(new Error('Unsupported create resource'));

    const url = `${baseUrl}/${API_PATH}`;
    const { json } = await httpClient(url, {
      method: 'POST',
      body: JSON.stringify(toApiPayload(params.data as any)),
    });
    const data = json?.data ?? json;
    return { data: fromApiRecord(data) };
  }

  // eslint-disable-next-line class-methods-use-this
  async update(_resource: string, params: { id: string | number; data: Record<string, unknown> }): Promise<any> {
    if (_resource !== RESOURCE) return Promise.reject(new Error('Unsupported update resource'));

    const url = `${baseUrl}/${API_PATH}/${params.id}`;
    const { json } = await httpClient(url, {
      method: 'PUT',
      body: JSON.stringify(toApiPayload(params.data as any, true)),
    });
    const data = json?.data ?? json;
    return { data: fromApiRecord({ id: params.id, ...data }) };
  }

  // eslint-disable-next-line class-methods-use-this
  async delete(_resource: string, params: { id: string | number }): Promise<any> {
    if (_resource !== RESOURCE) return Promise.reject(new Error('Unsupported delete resource'));

    const url = `${baseUrl}/${API_PATH}/${params.id}`;
    await httpClient(url, { method: 'DELETE' });
    return { data: { id: params.id } };
  }
}

export const maintenanceBannerDataProvider = new MaintenanceBannerDataProvider();

export default maintenanceBannerDataProvider;
